import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'g10-guest',
  templateUrl: './guest.component.html',
  styleUrls: ['./guest.component.css']
})
export class GuestComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
